import { OPS_REVIEWER_ROLES } from "../roles/turboOpsRoles.js";

/** Deals-screen manage tier. Matches the historical Ops paperwork panel gate. */
export const OPS_PAPERWORK_UI_MANAGE_ROLES = [
  "trainer",
  "marketing",
  "admin",
  "owner",
  "dev",
  "ads_guidance_editor",
  "platform_admin",
  "platform_dev",
  "platform_trainer",
] as const;

const REVIEWER_DEAL_PATCH_KEYS = new Set(["ready_to_deliver", "admin_hold_notes"]);

const REVIEWER_GET_OPS = new Set([
  "summary",
  "deals",
  "deal",
  "notifications",
  "tasks",
  "integration-events",
]);

export function canReviewOpsDeals(roles: readonly string[]): boolean {
  const held = new Set(roles.map((role) => role.trim().toLowerCase()));
  return OPS_REVIEWER_ROLES.some((role) => held.has(role));
}

/** Reads an ops-reviewer-only session may make. Org settings and books stay closed. */
export function opsReviewerMayRead(ops: string): boolean {
  return REVIEWER_GET_OPS.has(ops.trim().toLowerCase());
}

/**
 * Writes an ops reviewer may make on a deal that already exists.
 * Creating deals, seeding templates, deleting, and org settings stay on the manage tier.
 */
export function opsReviewerMayWrite(
  method: string,
  ops: string,
  body: Record<string, unknown> | null,
): boolean {
  const verb = method.toUpperCase();
  const op = ops.trim().toLowerCase();
  if (verb === "POST" && (op === "deal-type-match" || op === "submit-to-build")) return true;
  if (verb === "POST" && op === "salesperson") return body?.action === "request";
  if (verb === "PATCH" && op === "paperwork-item") return true;
  if (verb === "PATCH" && op === "deal") return reviewerDeliveryPatch(body);
  return false;
}

function reviewerDeliveryPatch(body: Record<string, unknown> | null): boolean {
  if (!body) return false;
  const keys = Object.keys(body).filter((key) => key !== "id");
  return keys.length > 0 && keys.every((key) => REVIEWER_DEAL_PATCH_KEYS.has(key));
}
